import { useEffect, useState } from 'react';
import {
  searchCalendarBookings,
  type CalendarBookingSearchResult,
} from '../lib/calendarBookingSearch';

export function useCalendarBookingSearch(businessId: string | undefined, query: string) {
  const [results, setResults] = useState<CalendarBookingSearchResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const trimmed = query.trim();
    if (!businessId || trimmed.length < 2) {
      setResults([]);
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const timer = window.setTimeout(() => {
      void searchCalendarBookings(businessId, trimmed)
        .then((data) => {
          if (!cancelled) setResults(data);
        })
        .catch((err) => {
          console.error('Calendar booking search failed:', err);
          if (!cancelled) {
            setError('Search failed. Try again.');
            setResults([]);
          }
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, 300);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [businessId, query]);

  return { results, loading, error };
}
